import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';

const ContractOwner = () => {
  const [field, meta, helpers] = useField('contract_owner');

  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <Input
      {...field}
      placeholder="ФИО заключившего договор"
      isValid={isValid}
      onChange={setValue}
    />
  );
};

export default ContractOwner;
